import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import { getRightByUserId, getOperaRight } from '@/api/right'
import { getToken } from '@/utils/cookies'
import { LocalStorage } from '@/utils/storage'
import { RightRoute, UserInfo, OpType } from '@/utils/types'
import store from '@/store'

export interface IRightInfo {
  accessroutes: RightRoute[]
  rpcUser: object
  userInfo: UserInfo
  opRight: OpType
  rpcUserRoleNames: String
  rpcRightMarkSet: any[]
}

@Module({ dynamic: true, store, name: 'right' })
class Right extends VuexModule implements IRightInfo {
  KEYS = {
    ROUTE: 'route_key',
    RPC_USER: 'rpc_key',
    USER_INFO: 'user_info_key',
    OP_RIGHT: 'op_right',
    RPC_USER_ROLE_NAMES: 'rpc-user-role-names',
    RPC_RIGHT_MARK_SET: 'rpc-right-mark-set'
  }

  rpcUserRoleNames = ''

  rpcRightMarkSet = []

  accessroutes: RightRoute[] = []
  rpcUser: object = {}
  userInfo: UserInfo = {
    id: -1,
    userName: '',
    userAccount: ''
  }

  opRight = {
    opType: '',
    opCode: ''
  }

  get userinfo () {
    return this.userInfo
  }

  @Mutation
  private SET_RPC_USER_ROLE_NAMES (rpcUserRoleNames: string) {
    this.rpcUserRoleNames = rpcUserRoleNames
  }

  @Mutation
  private SET_RPC_RIGHT_MARK_SET (rpcRightMarkSet: []) {
    this.rpcRightMarkSet = rpcRightMarkSet
  }

  @Mutation
  private SET_ACCESSROUTES (accessroutes: RightRoute[]) {
    this.accessroutes = accessroutes
  }

  @Mutation
  private SET_RPCUSER (rpcUser: object) {
    this.rpcUser = rpcUser
  }

  @Mutation
  private SET_USERINFO (userInfo: UserInfo) {
    this.userInfo = userInfo
  }

  @Mutation
  private SET_OPRIGHT (opRight: OpType) {
    this.opRight = opRight
  }

  @Action
  public async getRightByUserId (id: number) {
    // 判断是否已经获取过权限了
    const routes = LocalStorage.getObj(this.KEYS.ROUTE)
    if (!routes || routes.length === 0) {
      const res: any = await getRightByUserId({
        id: id,
        token: getToken()
      })
      if (res.object.accessRoutes.length === 0) {
        return
      }
      this.SET_ACCESSROUTES(res.object.accessRoutes)
      this.SET_RPCUSER(res.object.rpcLbUser)
      this.SET_USERINFO(res.object.rpcLbUser)
      this.SET_RPC_USER_ROLE_NAMES(res.object.rpcUserRoleNames)
      this.SET_RPC_RIGHT_MARK_SET(res.object.rpcRightMarkSet)
      // 路由权限存入session中
      LocalStorage.setObj(this.KEYS.ROUTE, res.object.accessRoutes)
      LocalStorage.setObj(this.KEYS.RPC_USER, res.object.rpcLbUser)
      LocalStorage.setObj(this.KEYS.USER_INFO, res.object.rpcLbUser)
      LocalStorage.setObj(this.KEYS.RPC_USER_ROLE_NAMES, res.object.rpcUserRoleNames)
      LocalStorage.setObj(this.KEYS.RPC_RIGHT_MARK_SET, res.object.rpcRightMarkSet)
    } else {
      this.SET_ACCESSROUTES(routes)
      this.SET_RPCUSER(LocalStorage.getObj(this.KEYS.RPC_USER))
      this.SET_USERINFO(LocalStorage.getObj(this.KEYS.USER_INFO))
      this.SET_RPC_RIGHT_MARK_SET(LocalStorage.getObj(this.KEYS.RPC_RIGHT_MARK_SET))
      this.SET_RPC_USER_ROLE_NAMES(LocalStorage.getObj(this.KEYS.RPC_USER_ROLE_NAMES))
    }
  }

  @Action
  public async getOperaRight (opData: { id: number, menuId: number }) {
    // 判断是否已经获取过权限了
    if (opData.menuId === -1) {
      return
    }
    const opRight = LocalStorage.getObj(this.KEYS.OP_RIGHT)
    if (!opRight || !opRight['op_' + opData.menuId]) {
      const { data } = await getOperaRight({
        id: opData.id,
        menuId: opData.menuId
      })
      // 缓存权限信息
      opRight['op_' + opData.menuId] = {
        opType: data.opType,
        opCode: data.opCode
      }
      this.SET_OPRIGHT(opRight)
      // 路由权限存入session中
      LocalStorage.setObj(this.KEYS.OP_RIGHT, opRight)
    } else {
      this.SET_OPRIGHT(opRight)
      LocalStorage.setObj(this.KEYS.OP_RIGHT, opRight)
    }
  }

  @Action
  public ResetAccessRoutes () {
    this.SET_ACCESSROUTES([])
    this.SET_RPCUSER([])
    this.SET_USERINFO({ id: NaN, userName: '', userAccount: '' })
    LocalStorage.remove(this.KEYS.ROUTE)
    LocalStorage.remove(this.KEYS.RPC_USER)
    LocalStorage.remove(this.KEYS.USER_INFO)
  }
}

export const RightModule = getModule(Right)
